export interface ITileItem {
  file: File,
  progress: number
  bytes: string
  duration: number
  buffer: AudioBuffer
  loading: boolean
}

export class TileItem implements ITileItem {
  file!: File;
  progress: number = 0;
  bytes!: string;
  duration!: number;
  buffer!: AudioBuffer;
  loading: boolean = false;
}
